import React, { useEffect, useState } from 'react';
import { useAccount } from '../../../../contexts/AccountContext';
import { useOperator } from '../../../../contexts/OperatorContext';

export type DeviceControlContext = {
  deviceControlType: DeviceControlType;
  setDeviceControlType(deviceControlType: DeviceControlType): void;
};
export type DeviceControlType = 'Hardware' | 'Apps';

export const DeviceControlContext = React.createContext<
  DeviceControlContext | undefined
>(undefined);

interface Props extends React.PropsWithChildren<any> {
  defaultControlType?: DeviceControlType;
}

export const DeviceControlProvider = ({
  children,
  defaultControlType = 'Hardware',
}: Props) => {
  const [deviceControlType, setDeviceControlType] =
    useState(defaultControlType);

  const { id: operatorId } = useOperator();

  useEffect(() => {
    setDeviceControlType(defaultControlType);
  }, [operatorId]);

  const handleDeviceControlChange = React.useCallback(
    (controlType: DeviceControlType) => {
      setDeviceControlType(controlType);
    },
    [setDeviceControlType]
  );

  return (
    <DeviceControlContext.Provider
      value={{
        deviceControlType,
        setDeviceControlType: handleDeviceControlChange,
      }}
    >
      {children}
    </DeviceControlContext.Provider>
  );
};

export const useDeviceControl = () => {
  const context = React.useContext(DeviceControlContext);

  if (!context)
    throw new Error(
      'useDeviceControl must be used within a DeviceControlProvider'
    );

  return context;
};
